import styled from "styled-components";
import Drawer from "components/shared/Drawer/Drawer";
import { usePlanShipmentDrawer } from "./PlanShipmentDrawerContext";

// Detail screens are full-page layouts (100dvh `main` shell + a 760px frame). Inside the
// drawer they should simply fill the panel. Their own modals use z-index 1000, so the
// drawer sits just beneath that.
const DRAWER_LAYER = 900;

const Screen = styled.div`
  height: 100%;
  overflow: hidden;

  main {
    height: 100% !important;
  }

  main > div {
    width: 100% !important;
    max-width: 100% !important;
    box-shadow: none !important;
  }
`;

const PlanShipmentDrawerHost = ({ children }) => {
  const { closeDrawer } = usePlanShipmentDrawer();

  return (
    <Drawer bare layer={DRAWER_LAYER} title="Plan shipment" onClose={() => closeDrawer()}>
      <Screen>{children}</Screen>
    </Drawer>
  );
};

export default PlanShipmentDrawerHost;
